import types from './types';

const loadAuthSuccess = user => ({
  type: types.AUTH_SUCCESS,
  payload: {
    user
  }
});

const loadAuthFail = data => ({
  type: types.AUTH_FAIL,
  payload: {
    data
  }
});

const logout = data => ({
  type: types.LOGOUT
});

export default {
  loadAuthSuccess,
  loadAuthFail,
  logout
};



// WEBPACK FOOTER //
// ./src/redux/auth/actions.js